import { NavLink } from "react-router-dom";
import { useFacets } from "../../api/hooks";
import styles from "./Product.module.css";

export function FacetSidebar({ inStock, onInStock }: { inStock: boolean; onInStock: (v: boolean) => void }) {
  const { data } = useFacets();

  return (
    <aside className={styles.sidebar} aria-label="Filters">
      <section>
        <h3>Availability</h3>
        <label className={styles.check}>
          <input type="checkbox" checked={inStock} onChange={(e) => onInStock(e.target.checked)} /> In stock only
        </label>
      </section>

      <section>
        <h3>Departments</h3>
        <ul>
          <li>
            <NavLink to="/products" end>
              All products
            </NavLink>
          </li>
          {data?.departments.map((d) => (
            <li key={d.slug}>
              <NavLink to={`/${d.slug}`}>
                {d.name} <span>({d.count})</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </section>

      <section>
        <h3>Brands</h3>
        <ul className={styles.brandList}>
          {data?.brands.map((b) => (
            <li key={b.slug}>
              <NavLink to={`/brands/${b.slug}`}>
                {b.name} <span>({b.count})</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </section>
    </aside>
  );
}
